export function getAccount(state) {
    return state.account;
}


